import httpClient from '../utils/http'
import { handleResponseAsync } from '../utils/HelperUtils'
import { normalize } from 'normalizr'
import { payrollNormalWorkHourSchema } from './../entities/schema'

export const payrollNormalWorkHourService = {
    getPayrollNormalWorkHours,
    getEmployeeNormalWorkHour,
}

function convertViewModelList(data) {
    const payrollNormalWorkHourListSchema = [payrollNormalWorkHourSchema]
    const normalizedData = normalize(data, payrollNormalWorkHourListSchema)
    return normalizedData.entities
}

function convertViewModel(data) {
    const normalizedData = normalize(data, payrollNormalWorkHourSchema)
    return normalizedData.entities
}

function getPayrollNormalWorkHours(data) {
    const url = '/api/payrollEmpNormalWorkingHour'

    return httpClient
        .post(url, data)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function getEmployeeNormalWorkHour(options) {
    const { employeeID } = options
    const url = `/api/payrollEmpNormalWorkingHour/${employeeID}`

    return httpClient
        .get(url)
        .then(handleResponseAsync)
        .then(res => convertViewModel(res.data))
}
